awardCalculation.classy.controller({
    name: "ApplicantsController",
    inject: ["$scope", "PutService", "ApplicationService", "CalculationService"],
    updateRes: function(ind) {
        if (this.$.ApplicationService.getAwardData().applicants[ind].Res_F1 === "1") {
            this.$.ApplicationService.getAwardData().applicants[ind].Res_F2 = "0";
        } else if (this.$.ApplicationService.getAwardData().applicants[ind].Res_F1 === ".5") {
            this.$.ApplicationService.getAwardData().applicants[ind].Res_F2 = ".5";
        } else if (this.$.ApplicationService.getAwardData().applicants[ind].Res_F1 === "0") {
            this.$.ApplicationService.getAwardData().applicants[ind].Res_F2 = "1";
        }
    },
    submit: function(scope, instance, form) {
        instance.options.factor  = .3;
        return this.PutService.putApplicant().then((data) => {
            console.log(data);
            this.CalculationService.reCalc();
            instance.stop(1);
        });
    }
});
